import { RetrievalMethod } from '@/feature/profiles/constants';
import type { Facesheet } from '@/feature/profiles/types';

type RequestMetadataVisibilityParams = {
  selectedMethods: RetrievalMethod[];
  selectedFacesheets?: Facesheet[];
  availableFacesheets?: Facesheet[];
};

// Edit-mode facesheet state can lose templateTypes, so fall back to the
// current profile's facesheet when we need to evaluate visibility. (Could be removed if BE send templateType)
const getResolvedTemplateTypes = (
  selectedFacesheet: Facesheet,
  availableFacesheets?: Facesheet[],
) => {
  if (selectedFacesheet.templateTypes.length > 0) {
    return selectedFacesheet.templateTypes;
  }

  const matchingFacesheet = availableFacesheets?.find(
    (facesheet) =>
      facesheet.facesheetConfigId === selectedFacesheet.facesheetConfigId,
  );

  return matchingFacesheet?.templateTypes ?? [];
};

export const isHIEOnlyrequest = ({
  selectedMethods,
  selectedFacesheets = [],
  availableFacesheets,
}: RequestMetadataVisibilityParams) => {
  const hieSelected = selectedMethods.includes(RetrievalMethod.HIE);
  const fullSelected = selectedMethods.includes(
    RetrievalMethod.PROVIDER_FACILITY,
  );

  if (!hieSelected || fullSelected || selectedFacesheets.length === 0) {
    return false;
  }

  return selectedFacesheets.every((selectedFacesheet) => {
    const templateTypes = new Set(
      getResolvedTemplateTypes(selectedFacesheet, availableFacesheets),
    );

    return templateTypes.size === 1 && templateTypes.has('HIE');
  });
};
